export default {
    scanLoading: state => state.scanLoading,
    metaArchLoading: state => state.metaArchLoading,
    archMetaDetails: state => state.archMetaDetails,
    annotateSaveLoading: state => state.annotateSaveLoading,
}